<div class="modal fade" id="{{deleteFormId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-m">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Confirmation</h6>
        <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"></button>
      </div>
      <div class="modal-body">
        <div class="col-12 mb-2 px-3">
            <div class="mb-4">
                {{deleteItemParameters?.title}}
            </div>
            <div class="row justify-content-center">
                <button type="button" class="btn btn-sm btn-danger me-2" style="width: 120px;" (click)="confirm()" *ngIf="formStatus == FormStatus.Normal">Confirm Delete</button>
                <button type="button" class="btn btn-sm btn-danger me-2" style="width: 120px;" disabled *ngIf="formStatus == FormStatus.Deleting">
                    <span class="spinner-border spinner-border-sm me-1"></span>
                    <span>Deleting...</span>
                </button>
                <button type="button" class="btn btn-sm btn-secondary" style="width: 120px;" data-bs-dismiss="modal" [disabled]="formStatus == FormStatus.Deleting" (click)="cancel()">Cancel Delete</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>